<div class="contentData">
  <header-without-assigned></header-without-assigned>
  <div class="" cdkDropListGroup>
    <mat-tab-group
      (selectedIndexChange)="change($event)"
      class="mgTop"
      mat-align-tabs="start"
      data-tour="analisis.estados"
    >
      <!-- <mat-tab label="Sin asignar"> </mat-tab> -->
      <mat-tab>
        <ng-template mat-tab-label>
          Sin Asignar
          <span
            class="badgeClass"
            [matBadge]="allCasesInitial.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          Asignado
          <span
            class="badgeClass"
            [matBadge]="allCasesAssigned.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          En proceso
          <span
            class="badgeClass"
            [matBadge]="allCasesRunning.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          Por aprobar
          <span
            class="badgeClass"
            [matBadge]="allCasesTobeApproved.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>

      <mat-tab label="Finalizado">
        <ng-template mat-tab-label>
          Finalizadas
          <span
            class="badgeClass"
            [matBadge]="toFinalize.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          General
          <span
            class="badgeClass"
            [matBadge]="allCases.length"
            matBadgeOverlap="false"
          ></span>
        </ng-template>
      </mat-tab>
      <!-- 
      <mat-tab label="Falso Positivo"> </mat-tab> -->
    </mat-tab-group>

    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      data-tour="analisis.lista"
    >
      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content first">
            <div class="header-child white">white</div>
          </div>
        </th>

        <td class="pointerMouse" mat-cell *matCellDef="let element">
          <div class="botOptions">
            <div>
              <mat-menu #menu="matMenu">
                <button (click)="edit(element)" mat-menu-item>Editar</button>
                <button
                  mat-menu-item
                  *ngIf="needApproval(element)"
                  (click)="approval(element)"
                >
                  Aprobar caso
                </button>
                <button
                  mat-menu-item
                  (click)="finishCase(element)"
                  *ngIf="
                    element.status == 'toFinalize' &&
                    canFinish &&
                    element.numberRas
                  "
                >
                  Archivar Caso
                </button>
              </mat-menu>
            </div>
            <div class="divCheckAproved">
              <mat-menu #checkAproved="matMenu">
                <div
                  *ngIf="element.approvalStatus == 'approved'"
                  class="divCheckAproved mar"
                >
                  <mat-icon class="checkAproved">check_circle</mat-icon>
                  <p class="checkAproved textAproved">Aprobado</p>
                </div>
                <div
                  *ngIf="
                    element?.caseType.approvalRoles?.levelTwo &&
                    element?.approvalStatus == 'requestLevelTwo'
                  "
                  class="divCheckAproved mar"
                >
                  <mat-icon class="checkAprove">error</mat-icon>
                  <p class="checkAprove textAproved">requiere aprobación ODC</p>
                </div>
                <div
                  *ngIf="
                    element.caseType.approvalRoles?.levelOne &&
                    element?.approvalStatus == 'requestLevelOne'
                  "
                  class="divCheckAproved mar"
                >
                  <mat-icon class="checkAprove">error</mat-icon>
                  <p class="checkAprove textAproved">
                    requiere aprobación Gerente
                  </p>
                </div>
              </mat-menu>
              <mat-icon
                *ngIf="element.approvalStatus != 'undefined'"
                [matMenuTriggerFor]="checkAproved"
                [matTooltip]="
                  element.approvalStatus == 'approved'
                    ? 'Caso Aprobado '
                    : 'No Aprobado'
                "
                [ngClass]="
                  element.approvalStatus == 'approved'
                    ? 'checkAproved'
                    : 'checkAprovedNot'
                "
                class="pointer"
                >check_circle</mat-icon
              >
              <mat-icon
                [matTooltip]="'No Aprobado'"
                class="checkAprovedNot"
                *ngIf="element.approvalStatus == 'undefined'"
                >check_circle</mat-icon
              >
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="gai">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <div class="header-child">Número</div>
          </div>
        </th>
        <td
          mat-cell
          class="pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          *matCellDef="let element"
        >
          {{ element.gai }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <div class="header-child">Descripción</div>
          </div>
        </th>
        <td
          mat-cell
          class="pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          *matCellDef="let element"
        >
          {{ element.description }}
        </td>
      </ng-container>
      <ng-container matColumnDef="caseType">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <div class="header-child">Tipo de caso</div>
          </div>
        </th>
        <td
          mat-cell
          class="pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          *matCellDef="let element"
        >
          {{ element.caseType.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="creator">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <div class="header-child" *ngIf="valueTab == 0">Creado Por</div>
            <div class="header-child" *ngIf="valueTab != 0">Asignado A</div>
          </div>
        </th>
        <td
          class="pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          mat-cell
          *matCellDef="let element"
        >
          <ng-container *ngIf="element.assigned">
            {{ element.assigned.fullname }}
          </ng-container>
          <ng-container *ngIf="!element.assigned">
            {{ element.creator.fullname }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content last">
            <div class="header-child">Fecha de Creación</div>
          </div>
        </th>
        <td
          class="mat-column-last pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          mat-cell
          *matCellDef="let element"
        >
          {{ element.createdAt | date : "d/M/yy hh:mm" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="datePast">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content last">
            <div class="header-child">Días transcurridos</div>
          </div>
        </th>
        <td
          class="mat-column-last pointerMouse"
          (click)="seeCase(element, element.status, element.a, element.b)"
          mat-cell
          *matCellDef="let element"
        >
          {{ datePast(element) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      class="paginator"
      [pageSizeOptions]="[10, 25, 40]"
      aria-label="Select page of roles"
    ></mat-paginator>
  </div>
</div>
